import { Injectable } from '@angular/core';


@Injectable()
export class LocalStorageService {

    public set(key:string, value:string):void {
        localStorage.setItem(key, value);
    }

    public get(key:string):string {
        return localStorage.getItem(key);
    }

    public setObject(key:string, data:Object):void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    public getObject(key:string):Object {
        return JSON.parse(localStorage.getItem(key));
    }

    public delete(key:string):void {
        return localStorage.removeItem(key);
    }

}


// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/services/localstorage.service.ts